import { useState } from "react";
import { Loader2, Upload, X, UserRound } from "lucide-react";
import { toast } from "sonner";
import { jamaahApi } from "@/lib/jamaahApi";
import { errMsg, fileUrl } from "@/lib/api";
import { useJamaah } from "@/context/JamaahContext";

export const AvatarField = () => {
  const { jamaah, setJamaah } = useJamaah();
  const [busy, setBusy] = useState(false);

  const run = async (fn) => {
    setBusy(true);
    try {
      const { data } = await fn();
      setJamaah(data);
      toast.success("Foto profil diperbarui");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  const pick = (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    run(() => jamaahApi.post("/jamaah/me/photo", fd));
  };

  return (
    <div className="flex items-center gap-4" data-testid="avatar-field">
      <div className="h-20 w-20 rounded-full bg-emerald-50 border border-dashed border-emerald-900/20 overflow-hidden flex items-center justify-center shrink-0">
        {jamaah.photo_path ? <img src={fileUrl(jamaah.photo_path)} alt="Foto" className="h-full w-full object-cover" data-testid="avatar-preview" /> : <UserRound size={28} className="text-emerald-700/50" />}
      </div>
      <div className="flex items-center gap-2">
        <label className="inline-flex items-center gap-2 rounded-full border border-emerald-900/15 px-3 py-1.5 text-xs font-medium cursor-pointer hover:bg-emerald-50">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />} {jamaah.photo_path ? "Ganti Foto" : "Unggah Foto"}
          <input type="file" accept="image/*" className="hidden" disabled={busy} onChange={(e) => pick(e.target.files?.[0])} data-testid="avatar-input" />
        </label>
        {jamaah.photo_path && (
          <button type="button" disabled={busy} onClick={() => run(() => jamaahApi.delete("/jamaah/me/photo"))} className="text-slate-400 hover:text-red-600" data-testid="avatar-remove"><X size={16} /></button>
        )}
      </div>
    </div>
  );
};
